import { throwError } from "../../lib/throwError";
import { get, post } from "../axiosUitils";
import { ManageActiveRecordParams } from "../../utils/types/activeRecord";

const basePath = "/dropdown/";

class DropdownService {
  getDropdownData = async (
    name: string,
    params?: any,
    notifyMessage?: boolean
  ): Promise<any> => {
    if (!name) {
      throwError("Name is required", "DropdownService");
    }
    return await get(`${basePath}${name}/`, { params, notifyMessage });
  };

  manageActiveRecord = async (
    params: ManageActiveRecordParams,
    notifyMessage?: boolean
  ): Promise<any> => {
    if (!params.table) {
      throwError("Table is required", "DropdownService");
    }
    if (!params.pk) {
      throwError("Primary key (pk) is required", "DropdownService");
    }
    if (typeof params.is_active !== "boolean") {
      throwError("is_active must be a boolean", "DropdownService");
    }
    return await post(`${basePath}manage-active-record/`, params, {
      notifyMessage,
    });
  };
}

export default new DropdownService();
